import { BCBS_CARRIERS_STATE_KEY, bcbsCarriersReducer } from './bcbsCarriers';
import {
    CARRIERS_BY_INSURANCE_TYPE_STATE_KEY,
    carriersByInsuranceTypeReducer,
} from './carriers';
import {
    PLANS_BY_CARRIER_ID_STATE_KEY,
    plansByCarrierIdReducer,
} from './plans';
import { combineReducers } from 'redux';

const insuranceReducer = combineReducers({
    [BCBS_CARRIERS_STATE_KEY]: bcbsCarriersReducer,
    [CARRIERS_BY_INSURANCE_TYPE_STATE_KEY]: carriersByInsuranceTypeReducer,
    [PLANS_BY_CARRIER_ID_STATE_KEY]: plansByCarrierIdReducer,
});

export default insuranceReducer;
